import './text-image.scss';
import ScrollTrigger from 'gsap/ScrollTrigger';
import gsap from 'gsap';

class TextImage {
	constructor() {
		gsap.registerPlugin(ScrollTrigger);
		this.gsap();
	}

	gsap() {
		gsap.from('.text-image .decoration__square',
			{
				scrollTrigger: {
					trigger: '.text-image',
				},
				opacity: 0,
				x: -50,
				y: 100,
				scale: .8,
				duration: 1,
				delay: 1
			});
		gsap.from('.text-image .img',
			{
				scrollTrigger: {
					trigger: '.text-image',
				},
				opacity: 0,
				x: 50,
				y: 100,
				scale: .8,
				duration: 1,
			});
		gsap.from('.text-image .content-col',
			{
				scrollTrigger: {
					trigger: '.text-image',
				},
				y: 50,
				duration: .8,
			});
	}

}
new TextImage();